import followersState from "./followers/state"
import followingState from "./following/state"
export default {
	activeProfile: {},
	activeProfileLoading: false,
	profileErrors: {},
	profilePostList: [],
	profileSavedPostList: [],
	profileTaggedPostList: [],
	profileFollowing: [],
	profilePostFetchCompleted: false,
	profilePostListLoading: false,
	profilePostListOffset: 0,
	profilePostListLimit: 6,
	profileSavedPostListOffset: 0,
	profileSavedPostListLoading: false,
	profileSavedPostFetchCompleted: false,
	profileTaggedPostListOffset: 0,
	profileTaggedPostListLoading: false,
	profileTaggedPostFetchCompleted: false,
	...followersState,
	...followingState
}